import CircularProgress from '@mui/material/CircularProgress';
import { Box, Spacer, Typography } from '@qbe/ads-core';
import React from 'react';

type LoadingProps = {
  text?: string;
  dataTestId?: string;
};

const Loading: React.FC<LoadingProps> = ({ text, dataTestId }) => (
  <Box data-testid={dataTestId}>
    <Spacer size="md" />
    <CircularProgress size={40} />
    {text ? (
      <>
        <Spacer size="xs" />
        <Typography>{text}</Typography>
      </>
    ) : null}
    <Spacer size="md" />
  </Box>
);

export default Loading;
